export function hexToStr(n: number): string {
    return '#' + n.toString(16).padStart(6, '0');
}

export function strToHex(s: string): number {
    return parseInt(s.replace('#', '0x'));
}